import { createContext, useContext } from 'react';
import type { RefObject } from 'react';

// Mirrors @flybits/design-system's PortalContainer type (not exported from the package root).
export type PortalContainer = HTMLElement | RefObject<HTMLElement | null> | null;

const PortalContainerContext = createContext<PortalContainer>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export function usePortalContainer(): PortalContainer {
  return useContext(PortalContainerContext);
}
